export const IN_REPAIR_PHASE_AWAITING_CUSTOMER = "Awaiting Customer";
export const IN_REPAIR_PHASE_LEGACY_NAME = IN_REPAIR_PHASE_AWAITING_CUSTOMER;
export const IN_REPAIR_PHASE_RO_SHIPMENT = "RO & Shipment";

export const IN_REPAIR_PHASE_OPTIONS = [
  { label: "Pre-Workflow", value: "Pre-Workflow" },
  { label: IN_REPAIR_PHASE_RO_SHIPMENT, value: IN_REPAIR_PHASE_RO_SHIPMENT },
  { label: "Vendor Inspection", value: "Vendor Inspection" },
  { label: "Quote Approval", value: "Quote Approval" },
  {
    label: IN_REPAIR_PHASE_AWAITING_CUSTOMER,
    value: IN_REPAIR_PHASE_AWAITING_CUSTOMER,
  },
  { label: "Repair & Return", value: "Repair & Return" },
];

export const normalizeInRepairPhase = (phase) => {
  if (!phase) return phase;
  return phase;
};

export const mapInRepairPhaseToApi = (phase) => {
  if (!phase) return phase;
  return phase;
};

export const IN_REPAIR_PRIORITY_OPTIONS = [
  { label: "P1", value: "P1" },
  { label: "P2", value: "P2" },
  { label: "P3", value: "P3" },
  { label: "P4", value: "P4" },
  { label: "P5", value: "P5" },
];

export const IN_REPAIR_WORKSTREAM_OPTIONS = [
  { label: "Customer Sale", value: "Customer Sale" },
  { label: "Exchange Core Return", value: "Exchange Core Return" },
  { label: "Contract / Programme", value: "Contract / Programme" },
  { label: "Repair Management", value: "Repair Management" },
  { label: "Stock Repair", value: "Stock Repair" },
  { label: "Unclassified", value: "Unclassified" },
];

export const IN_REPAIR_RAG_STATUS_OPTIONS = [
  { label: "As per plan", value: "As per plan" },
  { label: "Nearing Due", value: "Nearing Due" },
  { label: "Overdue", value: "Overdue" },
  { label: "No EDD", value: "No EDD" },
  { label: "Stalled", value: "Stalled" },
];

export const IN_REPAIR_GROUP_BY_OPTIONS = [
  { label: "Supply Chain Group", value: "sc_group" },
  { label: "RVE", value: "rve_owner" },
  { label: "Vendor", value: "vendor" },
  { label: "Priority Tier", value: "priority_tier" },
  { label: "RO Number", value: "ro_number" },
  { label: "No grouping", value: "none" },
];

/** Always-visible columns in Column Configuration (RO Number + Group by fields). */
export const IN_REPAIR_NON_MUTABLE_COLUMNS = [
  "ro_number",
  ...IN_REPAIR_GROUP_BY_OPTIONS.filter(
    (option) => option.value !== "none" && option.value !== "ro_number"
  ).map((option) => option.value),
];

export const IN_REPAIR_RAG_ACTIVE_BORDER = "#1a2b4a";

/** User-facing RAG status labels (keys/API color names still use green/amber/etc.). */
export const IN_REPAIR_RAG_DISPLAY_LABELS = {
  total: "total",
  green: "As per plan",
  Green: "As per plan",
  amber: "Nearing Due",
  Amber: "Nearing Due",
  red: "Overdue",
  Red: "Overdue",
  "Over due": "Overdue",
  grey: "No EDD",
  gray: "No EDD",
  Grey: "No EDD",
  Gray: "No EDD",
  no_edd: "No EDD",
  purple: "Stalled",
  Purple: "Stalled",
  stalled: "Stalled",
};

export const getInRepairRagDisplayLabel = (value) => {
  if (value == null || value === "") return value;
  const key = String(value).trim();
  return (
    IN_REPAIR_RAG_DISPLAY_LABELS[key] ??
    IN_REPAIR_RAG_DISPLAY_LABELS[key.toLowerCase()] ??
    key
  );
};

export const IN_REPAIR_RAG_FILTERS = [
  { key: "total", label: "total", variant: "total" },
  { key: "green", label: "As per plan", variant: "green" },
  { key: "amber", label: "Nearing Due", variant: "amber" },
  { key: "red", label: "Overdue", variant: "red" },
  { key: "no_edd", label: "No EDD", variant: "no_edd" },
  { key: "stalled", label: "Stalled", variant: "stalled" },
];

export const IN_REPAIR_RAG_FILTER_TO_API = {
  green: "Green",
  amber: "Amber",
  red: "Red",
  no_edd: "Gray",
  stalled: "Purple",
};

export const IN_REPAIR_RAG_COLORS = {
  total: {
    bg: "#e0f2fe",
    text: "var(--bondiblue-color)",
    dot: "var(--bondiblue-color)",
    activeBg: "#bae6fd",
  },
  green: {
    bg: "#dcfce7",
    text: "#166534",
    dot: "#22c55e",
    activeBg: "#bbf7d0",
  },
  amber: {
    bg: "#fef3c7",
    text: "#92400e",
    dot: "#f59e0b",
    activeBg: "#fde68a",
  },
  red: {
    bg: "#fee2e2",
    text: "#b91c1c",
    dot: "#ef4444",
    activeBg: "#fecaca",
  },
  no_edd: {
    bg: "#f3f4f6",
    text: "#4b5563",
    dot: "#9ca3af",
    activeBg: "#e5e7eb",
  },
  stalled: {
    bg: "#ede9fe",
    text: "#5b21b6",
    dot: "#7c3aed",
    activeBg: "#ddd6fe",
  },
};

export const IN_REPAIR_GROUP_SUMMARY_PILLS = [
  {
    key: "green",
    variant: "green",
    label: (count) => `${count} As per plan`,
  },
  {
    key: "amber",
    variant: "amber",
    label: (count) => `${count} Nearing Due`,
  },
  { key: "red", variant: "red", label: (count) => `${count} Overdue` },
  { key: "no_edd", variant: "no_edd", label: (count) => `${count} No EDD` },
  { key: "stalled", variant: "stalled", label: (count) => `${count} Stalled` },
];

export const IN_REPAIR_WORKSTREAM_STYLES = {
  "Customer Sale": { bg: "#fee2e2", color: "#7f1d1d" },
  "Exchange Core Return": { bg: "#fef9c3", color: "#713f12" },
  "Contract / Programme": { bg: "#e8f0fa", color: "#1a2b4a" },
  "Repair Management": { bg: "#e0f5f3", color: "#065f57" },
  "Stock Repair": { bg: "#f0eeeb", color: "#5a5855" },
  Unclassified: { bg: "#f3f4f6", color: "#4b5563" },
};

export const IN_REPAIR_STATUS_STYLES = {
  "As per plan": { bg: "#27a844", color: "#ffffff" },
  Stalled: { bg: "#7f77dd", color: "#ffffff" },
  "No EDD": { bg: "#888888", color: "#ffffff" },
  "Nearing Due": { bg: "#f59e0b", color: "#ffffff" },
  Overdue: { bg: "#e53935", color: "#ffffff" },
  "Over due": { bg: "#e53935", color: "#ffffff" },
};

export const IN_REPAIR_PRIORITY_STYLES = {
  P1: { bg: "#7f1d1d", color: "#ffffff" },
  P2: { bg: "#e53935", color: "#ffffff" },
  P3: { bg: "#f59e0b", color: "#ffffff" },
  P4: { bg: "#3b82c4", color: "#ffffff" },
  P5: { bg: "#f0eeeb", color: "#5a5855" },
};

export const IN_REPAIR_EDD_TEXT_STYLES = {
  red: { color: "#921f1c" },
  amber: { color: "#7c5e00" },
};

export const IN_REPAIR_BADGE_FONT_SIZE = "var(--font-size-13)";

export const IN_REPAIR_BADGE_BASE_SX = {
  display: "inline-block",
  px: "8px",
  py: "2px",
  borderRadius: "4px",
  fontSize: IN_REPAIR_BADGE_FONT_SIZE,
  fontWeight: 400,
  whiteSpace: "nowrap",
};

export const IN_REPAIR_SUGGESTED_ACTION_STYLE = {
  color: "#5a6478",
  fontSize: IN_REPAIR_BADGE_FONT_SIZE,
  fontWeight: 400,
  maxLength: 48,
};

export const IN_REPAIR_SC_GROUP_STYLE = {
  bg: "#e8f0fa",
  color: "#1a2b4a",
};

export const IN_REPAIR_PHASE_STYLES = {
  "Pre-Workflow": { bg: "#eeedfe", color: "#3c3489" },
  [IN_REPAIR_PHASE_RO_SHIPMENT]: { bg: "#e0f5f3", color: "#065f57" },
  [IN_REPAIR_PHASE_AWAITING_CUSTOMER]: { bg: "#e0f5f3", color: "#065f57" },
  default: { bg: "#e8f0fa", color: "#3b82c4" },
};

export const IN_REPAIR_COLUMN_MODULE = "RepairOrderRAGListing";

export const REPAIR_ORDER_RAG_LISTING_EXPORT_TYPE =
  "repair_order_rag_listing_xlxs";

export const IN_REPAIR_FILTER_LABELS = {
  rve: "RVE",
  rve_owner: "RVE",
  repair_vendors: "Vendor",
  vendor: "Vendor",
  phase: "Phase",
  priority_tier: "Priority Tier",
  workstream: "Workstream",
  commercial_workstream: "Workstream",
  sc_group: "Supply Chain Group",
  search: "Search",
  rag_status: "Status",
};

/** Canonical shared-filter order across In-Repair tabs (Listing baseline). */
export const IN_REPAIR_SHARED_FILTER_ORDER = [
  "rve",
  "rve_owner",
  "repair_vendors",
  "vendor",
  "phase",
  "priority_tier",
  "workstream",
  "commercial_workstream",
  "sc_group",
  "search",
];
